module.exports = __webpack_public_path__ + "static/media/GERD-GERD follow up-2@3x.319db940.png";